import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import { CashFundCard } from "./CashFundCard";
import CashFundCategories from "./CashFundCategories";
import "./CashFunds.css";  // Assuming you've added the above styles here

const AllCashFunds = () => {
  const [allFunds, setAllFunds] = useState([]);
  const [filteredFunds, setFilteredFunds] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get("/v1/cashfund")
      .then((response) => {
        if (response.data.status === "success" && response.data.data) {
          setAllFunds(response.data.data);
          setFilteredFunds(response.data.data); // default view = all
        } else {
          setError("Data fetch unsuccessful.");
        }
      })
      .catch(() => setError("Error fetching data."))
      .finally(() => setLoading(false));
  }, []);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    if (category === "ALL") {
      setFilteredFunds(allFunds);
    } else {
      setFilteredFunds(
        allFunds.filter(
          (fund) =>
            fund.category &&
            fund.category.toUpperCase() === category
        )
      );
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

return (
  <div className="cashfund-container">
    <CashFundCategories
      selected={selectedCategory}
      onSelect={handleCategorySelect}
      className="cashfund-categories"
    />
    {filteredFunds.length === 0 ? (
      <div className="no-cashfunds-fullscreen">
        We don't have any cashfunds.
      </div>
    ) : (
      <ul>
        {filteredFunds.map((fund) => (
          <CashFundCard fund={fund} key={fund.cash_fund_id} />
        ))}
      </ul>
    )}
  </div>
);



};

export default AllCashFunds;
